import styled from 'styled-components'
import { Select, MenuItem } from '@material-ui/core'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 410px;
  & > div {
    width: 100%;
  }
`

export const StyledSelect = styled(Select)`
  background-color: ${({ theme }) => theme.colors.white} !important;
  height: 65px;

  .MuiOutlinedInput-notchedOutline {
    border: 0;
  }
`

export const StyledMenuItem = styled(MenuItem)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightestGray} !important;
  cursor: pointer;
  padding: 8px 12px !important;
`

export const NoFilterSelected = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 18px;
  }

  label {
    color: ${({ theme }) => theme.colors.gray};
    font-family: 'Poppins', sans-serif;
    font-size: ${({ theme }) => theme.font.sizes.xsmall};
    font-weight: 500;
    margin-left: 18px;
  }
`

export const FilterSelected = styled.div`
  display: flex;
  align-items: center;

  img {
  }

  label {
    color: ${({ theme }) => theme.colors.gray};
    font-family: 'Poppins', sans-serif;
    font-size: ${({ theme }) => theme.font.sizes.xsmall};
    font-weight: 500;
    margin-left: 18px;
    text-transform: capitalize;
  }
`
